/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Dev_NoticeInputs */

const en_home_dev_notice = /** @type {(inputs: Home_Dev_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local development mode: mocked authentication (no network calls).`)
};

const fr_home_dev_notice = /** @type {(inputs: Home_Dev_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode développement local : authentification mockée (aucun appel réseau).`)
};

const ms_sg2_home_dev_notice = /** @type {(inputs: Home_Dev_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mod pembangunan tempatan: pengesahan diejek (tiada panggilan rangkaian).`)
};

/**
* | output |
* | --- |
* | "Local development mode: mocked authentication (no network calls)." |
*
* @param {Home_Dev_NoticeInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const home_dev_notice = /** @type {((inputs?: Home_Dev_NoticeInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Dev_NoticeInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_dev_notice(inputs)
	if (locale === "fr") return fr_home_dev_notice(inputs)
	return ms_sg2_home_dev_notice(inputs)
});